import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

/**
 * Persistent back affordance for pre-auth pages (forgot password, reset
 * password, join organization). Fixed to the top-left of the viewport rather
 * than the card, so it stays put and stays clickable no matter which state
 * the page is showing or how tall the card gets.
 */
const AuthBackButton = ({ to = "/", label = "Back to Sign In" }) => {
  const navigate = useNavigate();
  return (
    <button type="button" className="auth-back-btn" onClick={() => navigate(to)}>
      <FaArrowLeft />
      <span>{label}</span>
    </button>
  );
};

export default AuthBackButton;
